import * as actionTypes from './taxInvoiceActionType';
import { TaxInvoiceRequest, TaxInvoiceResponse } from 'routes/main/taxInvoice/types';

export const taxInvoiceRequest = (payload: TaxInvoiceRequest): actionTypes.TaxInvoiceRequestAction => {
  return {
    type: actionTypes.TAX_INVOICE_REQUEST,
    payload,
  };
};

export const taxInvoiceSuccess = (payload: TaxInvoiceResponse): actionTypes.TaxInvoiceSuccessAction => {
  return {
    type: actionTypes.TAX_INVOICE_SUCCESS,
    payload,
  };
};

export const taxInvoiceError = (message: string, error?: any): actionTypes.TaxInvoiceErrorAction => {
  return {
    type: actionTypes.TAX_INVOICE_ERROR,
    payload: {
      message,
      error,
    },
  };
};

export const taxInvoiceReset = (): actionTypes.TaxInvoiceResetAction => {
  return {
    type: actionTypes.TAX_INVOICE_RESET,
  };
};

// Export Audit Log Actions
export * from './auditLogActions';

// Export VAT Info Actions
export * from './vatInfoActions';

// Export Settings Actions
export * from './settingsActions';

